<!--
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-08-24 15:29:45
 * @LastEditTime: 2019-09-04 09:49:49
 * @LastEditors: yingbin
 -->
<template>
  <div class="layout-main">
      <vHeader></vHeader>
      <div class="emptyheader"></div>
      <v-gotop></v-gotop>
      <div class="wrap">
        <router-view ref="main" class="main"></router-view>
      </div>
      <vFooter></vFooter>
  </div>
</template>

<script>
import vHeader from "./components/header";
import vGotop from "../layout/components/goTop";
import vFooter from "./components/footer";
export default {
  mounted() {},
  components: {
    vHeader,
    vGotop,
    vFooter
  }
};
</script>
<style lang="less" scoped>
.layout-main {
  height: auto;
  background: #f0f0f7;
}
</style>